/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('accessWebClient')
    .controller('NodesActionsController', [
        '$scope', '$modalInstance', 'element', 'operationComplete',
        function ($scope, $modalInstance, element, operationComplete) {
            $scope.modal = $modalInstance.options;
            $scope.element = element;
            $scope.resource = 'sync_and_share_nodes';

            $scope.ok = function () {
                switch ($scope.modal.action) {
                    case 'delete':
                        $scope.modal.loading = true;
                        element.$delete({}, function () {
                            operationComplete(element.is_directory ? "nodes_operation_folder_deleted_success_message" : "nodes_operation_file_deleted_success_message");
                            $scope.modal.loading = false;
                            $modalInstance.close('reload_nodes');
                            $scope.$root.$broadcast('reload.contentStats');
                        }, function () {
                            $modalInstance.close('reload_nodes');
                        });
                        break;
                    case 'unsubscribe':
                        $scope.modal.loading = true;
                        $scope.element.$delete(function () {
                            operationComplete("Unsubscribed from folder.");
                            $scope.modal.loading = false;
                            $modalInstance.close('reload_nodes');
                            $scope.$root.$broadcast('reload.contentStats');
                        }, function () {
                            $modalInstance.close('reload_nodes');
                        });
                        break;
                    default:
                        $modalInstance.close('ok');
                }
            };

            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };

            $scope.close = function () {
                $modalInstance.close('reload_nodes');
            };

        }]);
